/*
    Implements the debug panel
 */

import {UITemplates} from "@/engine/UITemplates.js";
import {setTabChangeHandlers} from "@/engine/UIhelper/tab.js";
import {UIPHideable} from "@/engine/UIcomponents/UIPHideable.js";

export const UIPDebug = L.Control.extend({

    includes: [UIPHideable, UITemplates],

    initialize: function(stat, options) {
        this.options = options?options:{};

        if (this.options.position === undefined) {
            this.options.position = "bottomleft";
        }
        //array of stat objects
        this.stat = stat ? stat : [];
        this.refreshInterval = 1000;

        this.timerId = setInterval( function () {
            if (this.isVisible()) {
                this.stat.forEach(function (stat) {
                    stat.show();
                })
            }
        }.bind(this), this.refreshInterval);
    },

    onAdd: function(map) {
        this._div = L.DomUtil.create('div', 'pane debugPane'); // create a div with a class "info"
        this._div.innerHTML = this.getContent("debugPane")
        this._div.hidden = true;
        this.stat.forEach(function (stat) {
            stat.setDisplayContainer(this._div.querySelector(`section[for="debug-${stat.getId()}"]`));
        }.bind(this))
        setTabChangeHandlers(this._div);
        return this._div;
    },

});
